import React from 'react';
import { Grid, Card, CardContent, Box, Typography } from '@mui/material';
import HipaaCompliant from "../assets/images/HipaaCompliant.jpg";
import OncLogo from '../assets/images/ONC-Logo-2022.png';
import CMSLogo from '../assets/images/CMS-logo.png';
import NCQALogo from '../assets/images/NCQA-logo.png';
import DataCollectionLogo from '../assets/images/Data-Collection.png';

export const DataCertifications = () => {
    const dataSections = [
        {
            title: "Clinical Data Certification",
            subtitle: "ONC-ACB Certified",
            subtitleImages: [{ image: OncLogo, title: "ONC-ACB Certified" }],
            items: [
                { label: "EHR: CareTracker", detail: "ON-ACB Certification ID:", id: "15.0404.1569HAR.09.00.1.180701" },
                { label: "EHR: Amazing Charts", detail: "ON-ACB Certification ID:", id: "15.0404.1206AMAZ.11.07.1.231115" }
            ]
        },
        {
            title: "Regulatory Data Compliance",
            subtitleImages: [{ image: NCQALogo, title: "NCQA Certified" }, { image: CMSLogo, title: "CMS Certified" }],
            items: [
                "-Successful demonstration of the submission and acceptance of automated clinical quality measures",
                "-Accurate and successful use of standard vocabularies including but not limited to CPT-4, ICD-10, SNOMED, and LOINC."
            ]
        },
        {
            title: "Data Integration & Integrity",
            subtitleImages: [{ image: HipaaCompliant, title: "Hipaa Compliant" }],
            items: [
                "-Secure, direct connection to source EHRs systems utilizing 21 CFR Part 11 HIPAA, and ISO certified HITRUST, SOC2 compliant services and environments",
                "-Automated and manual testing gates at every stage to ensure preservation of data context and content"
            ]
        },
        {
            title: "Data Privacy Standards",
            subtitleImages: [{ image: DataCollectionLogo, title: "Data Privacy Standards" }],
            items: [
                "-Continuous Data Review Cycle",
                "-Multi-factor privacy reviews utilizing automated processes and manual audits internally and by independent reviewers"
            ]
        }
    ];

    const InfoCard = ({ section }) => (
        <Card raised sx={{
            minWidth: 275,
            margin: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            boxShadow: 0,
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'accentPanel.border',
            backgroundColor: 'background.paper',
            color: 'text.primary',
            height: '100%'
        }}>
            <CardContent sx={{ textAlign: 'center', height: '100%' }}>
                <Typography variant="p" component="div" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                    {section.title}
                </Typography>
                {section.subtitle && (
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                        {section.subtitle}
                    </Typography>
                )}
                {section?.subtitleImages.length > 0 &&
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 2
                    }}>
                        {section.subtitleImages.map(({ image, title }, index) => (
                            <Box key={index} component="img" src={image} alt={title} sx={{ maxWidth: '50px', maxHeight: '50px', margin: .5 }} />
                        ))}
                    </Box>
                }
                <Box sx={{ marginTop: 2 }}>
                    {section.items.map((item, index) => (
                        typeof item === 'string' ? (
                            <Typography variant="body2" key={index} sx={{ textAlign: 'center', marginBottom: 1 }}>
                                {item}
                            </Typography>
                        ) : (
                            <Typography variant="body2" key={index} sx={{ textAlign: 'center', marginBottom: 1 }}>
                                <strong>{item.label}</strong>
                                <br />
                                <span>{item.detail}</span>
                                <br />
                                {item.id}
                            </Typography>
                        )
                    ))}
                </Box>
            </CardContent>
        </Card >
    );

    return (
        <Grid container spacing={2} justifyContent="center">
            {dataSections.map((section, index) => (
                <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
                    <InfoCard section={section} />
                </Grid>
            ))}
        </Grid>
    )
}